import { createSlice } from '@reduxjs/toolkit'
import {
  fetchClient,
  fetchCurrencyRate,
  fetchManager,
  updateClientVip,
} from './thunk'

const initialState = {
  clientData: {},
  clientDataLoading: false,
  clientDataError: undefined,

  managerData: {},
  managerLoading: false,
  managerError: undefined,

  currencyRateData: [],
  currencyRateLoading: false,
  currencyRateError: undefined,

  vipUpdateLoading: false,
  vipUpdateError: undefined,
}

const slice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    clearManagerData(state) {
      state.managerData = {}
    },
  },
  extraReducers: {
    [fetchClient.pending]: (state) => {
      state.clientDataLoading = true
    },
    [fetchClient.fulfilled]: (state, { payload }) => {
      state.clientDataLoading = false
      state.clientData = payload || {}
    },
    [fetchClient.rejected]: (state, { error }) => {
      state.clientDataLoading = false
      state.clientDataError = error
    },
    [fetchManager.pending]: (state) => {
      state.managerLoading = true
    },
    [fetchManager.fulfilled]: (state, { payload }) => {
      state.managerLoading = false
      state.managerData = payload || {}
    },
    [fetchManager.rejected]: (state, { error }) => {
      state.managerLoading = false
      state.managerError = error
    },
    [fetchCurrencyRate.pending]: (state) => {
      state.currencyRateLoading = true
    },
    [fetchCurrencyRate.fulfilled]: (state, { payload }) => {
      state.currencyRateLoading = false
      state.currencyRateData = payload || []
    },
    [fetchCurrencyRate.rejected]: (state, { error }) => {
      state.currencyRateLoading = false
      state.currencyRateError = error
    },
    [updateClientVip.pending]: (state) => {
      state.vipUpdateLoading = true
      state.vipUpdateError = undefined
    },
    [updateClientVip.fulfilled]: (state) => {
      state.vipUpdateLoading = false
    },
    [updateClientVip.rejected]: (state, { payload, error }) => {
      state.vipUpdateLoading = false
      state.vipUpdateError = payload || error
    },
  },
})
export const { clearManagerData } = slice.actions
export const reducer = slice.reducer
export const selectorClients = (state) => state[slice.name]
export default slice
